/* Custom JS for Sample Order Page */

document.addEventListener('DOMContentLoaded', () => {
  const config = window.sampleOrderConfig || {};
  // Sonderkacheln teilen sich die Kachel-Optik (.sample-item), sind aber
  // keine Muster – sie dürfen weder gezählt noch auswählbar sein.
  const items = Array.from(document.querySelectorAll('.sample-item:not([data-promo])'));
  const listEl = document.querySelector('.sample-list');
  const countEl = document.getElementById('current-samples-count');
  const openBtn = document.getElementById('open-sample-order-modal');
  const bar = document.querySelector('[data-sample-bar]');
  const slotsEl = document.querySelector('[data-sample-slots]');
  const maxSamples = config.maxSamples || 5;
  const selectedSamples = new Map(); // id -> { title, thumb, handle }

  const STORAGE_KEY = 'framelinSampleOrderSelection';

  // ─── Facetten, Suche, Sortierung ───────────────────────────────
  const facetInputs = Array.from(document.querySelectorAll('.sample-facet__input'));
  const facetsEl = document.querySelector('[data-facets]');
  const scrimEl = document.querySelector('.sample-facets__scrim');
  const searchEl = document.querySelector('[data-sample-search]');
  const sortEl = document.querySelector('[data-sample-sort]');
  const resultCountEl = document.querySelector('[data-result-count]');
  const emptyEl = document.querySelector('[data-sample-empty]');
  const filterBtn = document.querySelector('[data-facets-open]');
  const facetBadge = document.querySelector('[data-facet-badge]');

  // "typ" zuerst, weil die Gruppe am stärksten reduziert (73 -> 13)
  const GROUPS = ['typ', 'farbe', 'breite', 'stil'];
  const state = { typ: [], farbe: [], breite: [], stil: [], q: '', sort: 'beliebt' };

  // Kuratierte Reihenfolge für "Beliebteste", ein Produkt-Handle pro Zeile
  const popularOrder = String(config.popularOrder || '')
    .split(/[\n,]/).map(s => s.trim().toLowerCase()).filter(Boolean);

  /** Umlautfeste Slugs für URL und Vergleich: "Weiß" -> "weiss" */
  function slug(value) {
    return String(value).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '');
  }

  function widthBucket(mm) {
    if (mm <= 15) return 'schmal';
    if (mm <= 20) return 'mittel';
    return 'breit';
  }

  // Werte pro Kachel einmalig vorberechnen
  const meta = items.map((item, index) => {
    const handle = (item.dataset.productHandle || '').toLowerCase();
    const rank = popularOrder.indexOf(handle);
    return {
      el: item,
      index: index,
      handle: handle,
      title: (item.dataset.productTitle || '').toLowerCase(),
      typ: (item.dataset.typ || '').split(' ').filter(Boolean),
      farbe: (item.dataset.colors || item.dataset.color || '').split('|').filter(Boolean).map(slug),
      breite: [widthBucket(parseInt(item.dataset.widthMm, 10) || 0)],
      stil: (item.dataset.stil ? [item.dataset.stil] : []).map(slug),
      width: parseInt(item.dataset.widthMm, 10) || 0,
      bestseller: item.dataset.bestseller === 'true',
      neu: (item.dataset.features || '').toLowerCase().indexOf('neuheit') !== -1,
      popularRank: rank === -1 ? Number.MAX_SAFE_INTEGER : rank
    };
  });

  /** Trifft die Kachel alle Gruppen? ODER innerhalb, UND zwischen den Gruppen. */
  function matches(entry, skipGroup) {
    for (const group of GROUPS) {
      if (group === skipGroup) continue;
      const active = state[group];
      if (!active.length) continue;
      if (!entry[group].some(v => active.indexOf(v) !== -1)) return false;
    }
    return true;
  }

  function matchesAll(entry) {
    return matches(entry, null) && (!state.q || entry.title.indexOf(state.q) !== -1);
  }

  function activeFacetCount() {
    return GROUPS.reduce((sum, g) => sum + state[g].length, 0);
  }

  function updateCounts() {
    facetInputs.forEach(input => {
      const group = input.dataset.facetGroup;
      const value = slug(input.value);
      // Zahl gilt für die aktuelle Kombination der ANDEREN Gruppen
      const n = meta.filter(e =>
        e[group].indexOf(value) !== -1 &&
        matches(e, group) &&
        (!state.q || e.title.indexOf(state.q) !== -1)
      ).length;
      const countEl2 = input.closest('.sample-facet__opt').querySelector('[data-facet-count]');
      if (countEl2) countEl2.textContent = String(n);
      input.closest('.sample-facet__opt').classList.toggle('is-empty', n === 0 && !input.checked);
    });
  }

  // ─── Dubletten-Warnung (nur Dev) ──────────────────────────────
  // Meldet Rahmen, die sich Bildquelle oder Maßangabe teilen. Beides macht
  // zwei Kacheln für den Kunden ununterscheidbar. Sichtbar im Theme-Editor
  // oder mit ?sampledebug=1 an der URL.
  (function warnAboutDuplicates() {
    const devMode = (window.Shopify && window.Shopify.designMode) ||
                    location.search.indexOf('sampledebug') !== -1;
    if (!devMode) return;

    /** Gruppiert Titel nach einem Schlüssel und liefert nur die Mehrfachbelegungen */
    function duplicatesBy(keyFn) {
      const map = new Map();
      items.forEach(item => {
        const key = keyFn(item);
        if (!key) return;
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(item.dataset.productTitle || '(ohne Titel)');
      });
      return Array.from(map.entries())
        .filter(e => e[1].length > 1)
        .sort((a, b) => b[1].length - a[1].length);
    }

    const axes = [
      ['Kachelbild (_Seite)', duplicatesBy(i => (i.dataset.previewSrc || '').split('?')[0]),
       'zwei Kacheln zeigen dasselbe Foto'],
      ['Slot-Bild (_Quer)', duplicatesBy(i => (i.dataset.querSrc || '').split('?')[0]),
       'in der Sticky-Leiste nicht unterscheidbar'],
      ['Maßangabe', duplicatesBy(i => (i.dataset.widthMm || '') + '×' + (i.dataset.heightMm || '')),
       'gleiches Label unter der Kachel']
    ];

    let any = false;
    axes.forEach(axis => {
      const name = axis[0], dups = axis[1], why = axis[2];
      if (!dups.length) return;
      any = true;
      const affected = dups.reduce((sum, e) => sum + e[1].length, 0);
      console.warn('[Muster] ' + name + ': ' + dups.length + ' Dubletten über ' +
                   affected + ' von ' + items.length + ' Rahmen – ' + why);
      dups.forEach(e => console.warn('   ' + e[1].join(' / ') + '  →  ' + e[0].split('/').pop()));
    });
    if (!any) console.info('[Muster] Keine Dubletten bei Bild oder Maß.');
  })();

  const bestsellerCount = meta.filter(e => e.bestseller).length;
  const MIN_BESTSELLER = 5;

  function sortEntries(list) {
    const by = state.sort;
    return list.slice().sort((a, b) => {
      if (by === 'az') return a.el.dataset.productTitle.localeCompare(b.el.dataset.productTitle, 'de');
      if (by === 'breite') return (a.width - b.width) || (a.index - b.index);
      if (by === 'neu') return (Number(b.neu) - Number(a.neu)) || (a.index - b.index);

      // "Beliebteste". Der Bestseller-Tag trägt erst ab MIN_BESTSELLER Produkten,
      // sonst kippt die Sortierung praktisch auf die Kollektionsreihenfolge –
      // und die ist alphabetisch, was wie ein Fehler aussieht. Deshalb greift
      // darunter die kuratierte Liste aus dem Section-Setting.
      if (bestsellerCount >= MIN_BESTSELLER) {
        return (Number(b.bestseller) - Number(a.bestseller)) || (a.index - b.index);
      }
      return (a.popularRank - b.popularRank)
          || (Number(b.bestseller) - Number(a.bestseller))
          || (a.index - b.index);
    });
  }

  function applyFacets() {
    const visible = meta.filter(matchesAll);
    meta.forEach(e => e.el.classList.toggle('hidden', visible.indexOf(e) === -1));

    // Reihenfolge im Grid setzen
    const ordered = sortEntries(visible).map(e => e.el);

    // Sonderkacheln an feste Positionen einmischen. Bei aktivem Filter oder
    // aktiver Suche raus – ein Holz-Set im Schwarz-Filter wäre irreführend.
    // Frisch abfragen, weil leere Set-Kacheln vorher entfernt worden sein können.
    const filtersActive = activeFacetCount() > 0 || state.q !== '';
    Array.from(document.querySelectorAll('[data-promo]')).forEach(promo => {
      promo.classList.toggle('hidden', filtersActive);
      if (filtersActive) {
        ordered.push(promo);
      } else {
        const pos = Math.min(parseInt(promo.dataset.promoPosition, 10) || 0, ordered.length);
        ordered.splice(pos, 0, promo);
      }
    });

    ordered.forEach(el => listEl.appendChild(el));

    if (resultCountEl) resultCountEl.textContent = String(visible.length);
    if (emptyEl) emptyEl.hidden = visible.length !== 0;
    if (listEl) listEl.hidden = visible.length === 0;

    const n = activeFacetCount();
    if (facetBadge) facetBadge.textContent = n ? ' (' + n + ')' : '';
    if (filterBtn) {
      if (n) filterBtn.setAttribute('data-active', 'true');
      else filterBtn.removeAttribute('data-active');
    }

    updateCounts();
  }

  // ─── URL-State ────────────────────────────────────────────────
  function stateToQuery() {
    // Von Hand gebaut, damit die Kommas lesbar bleiben (?farbe=holz,gold)
    const parts = [];
    GROUPS.forEach(g => {
      if (state[g].length) parts.push(g + '=' + state[g].map(encodeURIComponent).join(','));
    });
    if (state.q) parts.push('q=' + encodeURIComponent(state.q));
    if (state.sort !== 'beliebt') parts.push('sort=' + state.sort);
    return location.pathname + (parts.length ? '?' + parts.join('&') : '');
  }

  function readStateFromUrl() {
    const params = new URLSearchParams(location.search);
    GROUPS.forEach(g => {
      const raw = params.get(g);
      state[g] = raw ? raw.split(',').filter(Boolean) : [];
    });
    state.q = (params.get('q') || '').toLowerCase();
    state.sort = params.get('sort') || 'beliebt';

    facetInputs.forEach(input => {
      input.checked = state[input.dataset.facetGroup].indexOf(slug(input.value)) !== -1;
    });
    if (searchEl) searchEl.value = params.get('q') || '';
    if (sortEl) sortEl.value = state.sort;
  }

  function pushUrl(replace) {
    const url = stateToQuery();
    if (url === location.pathname + location.search) return;
    history[replace ? 'replaceState' : 'pushState']({ sampleFacets: true }, '', url);
  }

  facetInputs.forEach(input => {
    input.addEventListener('change', () => {
      const group = input.dataset.facetGroup;
      const value = slug(input.value);
      const at = state[group].indexOf(value);
      if (input.checked && at === -1) state[group].push(value);
      else if (!input.checked && at !== -1) state[group].splice(at, 1);
      pushUrl(false);
      applyFacets();
    });
  });

  if (sortEl) {
    sortEl.addEventListener('change', () => {
      state.sort = sortEl.value;
      pushUrl(false);
      applyFacets();
    });
  }

  if (searchEl) {
    let searchTimer;
    searchEl.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        state.q = searchEl.value.trim().toLowerCase();
        pushUrl(true);
        applyFacets();
      }, 200);
    });
  }

  document.querySelectorAll('[data-facet-reset]').forEach(btn => {
    btn.addEventListener('click', () => {
      GROUPS.forEach(g => { state[g] = []; });
      state.q = '';
      facetInputs.forEach(i => { i.checked = false; });
      if (searchEl) searchEl.value = '';
      pushUrl(false);
      applyFacets();
    });
  });

  window.addEventListener('popstate', () => {
    readStateFromUrl();
    applyFacets();
  });

  // ─── Bottom-Sheet auf Mobil ───────────────────────────────────
  function setSheet(open) {
    if (!facetsEl) return;
    facetsEl.classList.toggle('is-open', open);
    if (scrimEl) scrimEl.hidden = !open;
    document.body.classList.toggle('sample-facets-open', open);
    if (filterBtn) filterBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (filterBtn) filterBtn.addEventListener('click', () => setSheet(true));
  document.querySelectorAll('[data-facets-close]').forEach(el => {
    el.addEventListener('click', () => setSheet(false));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && facetsEl && facetsEl.classList.contains('is-open')) setSheet(false);
  });

  readStateFromUrl();
  applyFacets();

  // ─── Auswahl ───────────────────────────────────────────────────
  /** Shopify-CDN-URL auf eine Zielbreite bringen, egal ob schon ein Parameter dranhängt */
  function atWidth(url, w) {
    if (!url) return '';
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /** Slot-Bild: flache Leiste statt Ecke – auf 40px ist eine Farbfläche lesbar,
      eine Rahmenecke nicht. Ohne Quer-Bild bleibt die Eckansicht. */
  function thumbFor(item) {
    return atWidth(item.dataset.querSrc || item.dataset.previewSrc || '', 160);
  }

  function persist() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(selectedSamples.keys())));
    } catch (_) {}
  }

  function addSample(item) {
    selectedSamples.set(item.dataset.productId, {
      title: item.dataset.productTitle,
      thumb: thumbFor(item),
      handle: item.dataset.productHandle || ''
    });
  }

  let pulseTimer;

  /** Leiste kurz hervorheben – dort steht der Hinweis und dort liegt die Lösung */
  function pulseBar() {
    if (!bar) return;
    bar.classList.remove('is-pulsing');
    void bar.offsetWidth; // Reflow, damit die Animation erneut startet
    bar.classList.add('is-pulsing');
    clearTimeout(pulseTimer);
    pulseTimer = setTimeout(() => bar.classList.remove('is-pulsing'), 600);
  }

  function toggleItem(item) {
    const key = item.dataset.productId;
    if (selectedSamples.has(key)) {
      selectedSamples.delete(key);
    } else {
      // Limit erreicht: kein Dialog, keine Meldung an der Kachel. Stattdessen
      // blinkt die Leiste kurz auf – dort steht, was zu tun ist.
      if (selectedSamples.size >= maxSamples) {
        pulseBar();
        return;
      }
      addSample(item);
    }
    persist();
    render();
  }

  function removeById(id) {
    if (!selectedSamples.delete(id)) return;
    persist();
    render();
  }

  function render() {
    const count = selectedSamples.size;
    const atLimit = count >= maxSamples;

    if (countEl) countEl.textContent = String(count);

    // Der Limit-Hinweis steht einmal in der Leiste, nicht 73-mal im Grid
    const hintEl = document.querySelector('[data-bar-hint]');
    if (hintEl) {
      hintEl.textContent = atLimit
        ? hintEl.dataset.hintLimit
        : hintEl.dataset.hintDefault;
      hintEl.classList.toggle('is-limit', atLimit);
    }

    items.forEach(item => {
      const isSelected = selectedSamples.has(item.dataset.productId);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      if (!isSelected && atLimit) {
        item.setAttribute('aria-disabled', 'true');
      } else {
        item.removeAttribute('aria-disabled');
      }
    });

    if (openBtn) openBtn.disabled = count === 0;
    renderSlots();
  }

  function renderSlots() {
    if (!slotsEl) return;
    const entries = Array.from(selectedSamples.entries());
    Array.from(slotsEl.children).forEach((slot, i) => {
      const entry = entries[i];
      if (!entry) {
        slot.className = 'sample-bar__slot';
        slot.textContent = '';
        return;
      }
      const id = entry[0];
      const data = entry[1];
      slot.className = 'sample-bar__slot is-filled';
      slot.innerHTML =
        '<img src="' + escapeHtml(data.thumb) + '" alt="" width="48" height="48">' +
        '<button type="button" class="sample-bar__remove" data-remove-id="' + escapeHtml(id) +
        '" aria-label="' + escapeHtml(data.title) + ' entfernen">&times;</button>';
    });
  }

  // Ganze Kachel ist ein <button> – Enter/Space kommen nativ mit
  items.forEach(item => {
    item.addEventListener('click', () => toggleItem(item));
  });

  // × im Slot entfernt die Auswahl und deselektiert die Kachel im Grid.
  // Ohne Hover (Touch) ist das × versteckt: erster Tap auf den Slot blendet
  // es ein, der zweite entfernt. Verhindert Fehlgriffe auf kleinen Slots.
  const canHover = window.matchMedia('(hover: hover)').matches;
  if (slotsEl) {
    slotsEl.addEventListener('click', (e) => {
      const btn = e.target.closest('.sample-bar__remove');
      if (btn) {
        removeById(btn.dataset.removeId);
        return;
      }
      if (canHover) return;
      const slot = e.target.closest('.sample-bar__slot.is-filled');
      if (!slot) return;
      const wasArmed = slot.classList.contains('is-armed');
      slotsEl.querySelectorAll('.is-armed').forEach(s => s.classList.remove('is-armed'));
      if (!wasArmed) slot.classList.add('is-armed');
    });

    // Tap daneben entschärft wieder
    if (!canHover) {
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.sample-bar__slots')) {
          slotsEl.querySelectorAll('.is-armed').forEach(s => s.classList.remove('is-armed'));
        }
      });
    }
  }

  // Leiste einblenden, sobald das Grid im Viewport ist.
  // Bewusst fail-open: erst sichtbar setzen, dann vom Observer ausblenden
  // lassen. Feuert der Observer nie, bleibt der Bestell-Button erreichbar
  // statt unsichtbar zu hängen.
  if (bar) {
    bar.classList.add('is-visible');
    if (listEl && 'IntersectionObserver' in window) {
      const barObserver = new IntersectionObserver(
        (entries) => entries.forEach(e => bar.classList.toggle('is-visible', e.isIntersecting))
      );
      barObserver.observe(listEl);
    }
  }

  // Auswahl aus sessionStorage wiederherstellen (Reload verwirft nichts)
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && !config.formSuccess) {
      JSON.parse(stored).forEach(id => {
        const item = items.find(i => i.dataset.productId === id);
        if (item && selectedSamples.size < maxSamples) addSample(item);
      });
    }
  } catch (_) {}

  render();


  // ─── Modal Logic ───────────────────────────────────────────────
  const modal = document.getElementById('sample-order-modal');
  const modalSelectionEl = document.getElementById('sample-modal-selection');
  const form = document.querySelector('#sample-order-modal form.sof-form');
  const submitBtn = document.getElementById('sof-submit');
  const errorEl = document.getElementById('sof-error');

  // Hidden fields to populate from selection + UI state
  const samplesInput = document.getElementById('sof-samples');
  const samplesCountInput = document.getElementById('sof-samples-count');
  const bodyInput = document.getElementById('sof-body');

  function openModal(view) {
    if (!modal) return;
    if (view === 'success') {
      // Success view rendered server-side; just show modal
    } else {
      renderSelection();
      showView('form');
    }
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('sample-modal-open');

    // Fokus ins erste Feld, damit man sofort tippen kann.
    // Direkt setzen statt über requestAnimationFrame – rAF läuft nicht
    // zuverlässig, wenn der Tab gerade nicht gerendert wird.
    if (view !== 'success') {
      const first = modal.querySelector('#sof-email');
      if (first) {
        first.focus();
        if (document.activeElement !== first) setTimeout(() => first.focus(), 0);
      }
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('sample-modal-open');
  }

  function showView(view) {
    if (!modal) return;
    modal.querySelectorAll('.sample-modal__view').forEach(v => {
      v.hidden = v.dataset.view !== view;
    });
  }

  function renderSelection() {
    if (!modalSelectionEl) return;
    const count = selectedSamples.size;
    const titles = Array.from(selectedSamples.values()).map(s => s.title);

    if (count === 0) {
      modalSelectionEl.innerHTML = '';
      return;
    }

    modalSelectionEl.innerHTML = `
      <div class="sample-modal__selection-header">
        ${count} ${count === 1 ? 'ausgewähltes Muster' : 'ausgewählte Muster'}
      </div>
      <ul class="sample-modal__selection-list">
        ${titles.map(t => `<li>${escapeHtml(t)}</li>`).join('')}
      </ul>
    `;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  // Modal open trigger
  if (openBtn) {
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (selectedSamples.size === 0) return;
      openModal('form');
    });
  }

  // Close triggers
  if (modal) {
    modal.querySelectorAll('[data-sample-modal-close]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  // ─── PLZ füllt den Ort vor ─────────────────────────────────────
  // Primär openplzapi.org: liefert den Ortsnamen, nicht den Stadtteil
  // (20095 -> "Hamburg", nicht "Hamburg Sankt Georg"). Fällt der Dienst aus,
  // greift zippopotam.us. Scheitert beides, bleibt das Feld normal tippbar.
  // Ein vom Nutzer selbst gesetzter Ort wird nie überschrieben.
  (function setupCityAutofill() {
    const plzEl = document.getElementById('sof-plz');
    const ortEl = document.querySelector('[data-autofill-city]');
    if (!plzEl || !ortEl) return;

    let cityTouched = false;
    let lastLookup = '';
    ortEl.addEventListener('input', () => { cityTouched = ortEl.value.trim() !== ''; });

    function lookup(plz) {
      return fetch('https://openplzapi.org/de/Localities?postalCode=' + plz)
        .then(res => (res.ok ? res.json() : null))
        .then(data => (data && data[0] && data[0].name) || null)
        .catch(() => null)
        .then(name => {
          if (name) return name;
          return fetch('https://api.zippopotam.us/de/' + plz)
            .then(res => (res.ok ? res.json() : null))
            .then(d => (d && d.places && d.places[0] && d.places[0]['place name']) || null)
            .catch(() => null);
        });
    }

    plzEl.addEventListener('input', () => {
      const plz = plzEl.value.trim();
      if (!/^\d{5}$/.test(plz) || plz === lastLookup) return;
      lastLookup = plz;

      lookup(plz).then(name => {
        if (!name || cityTouched) return;
        ortEl.value = name;
      });
    });
  })();

  // ─── Form submit (native Shopify contact form) ─────────────────
  if (form) {
    form.addEventListener('submit', (e) => {
      if (errorEl) errorEl.hidden = true;
      // Ab dem ersten Absendeversuch dürfen leere Pflichtfelder rot werden
      form.classList.add('was-submitted');

      // Validate: at least 1 sample must be selected
      if (selectedSamples.size === 0) {
        e.preventDefault();
        if (errorEl) {
          errorEl.textContent = 'Bitte wähle mindestens ein Muster aus.';
          errorEl.hidden = false;
        }
        closeModal();
        return;
      }

      // Fill hidden fields before native submit
      const titles = Array.from(selectedSamples.values()).map(s => s.title);
      const count = titles.length;

      if (samplesInput) samplesInput.value = titles.join(', ');
      if (samplesCountInput) samplesCountInput.value = String(count);

      // Build readable body with all details for the admin email
      const emailVal = form.querySelector('#sof-email')?.value.trim() || '';
      const fullName = form.querySelector('#sof-name')?.value.trim() || '';
      // Ein Namensfeld statt zwei – für Klaviyo am letzten Leerzeichen trennen
      const nameParts = fullName.split(/\s+/);
      const nachname = nameParts.length > 1 ? nameParts.pop() : '';
      const vorname = nameParts.join(' ');
      const strasse = form.querySelector('#sof-strasse')?.value.trim() || '';
      const plz = form.querySelector('#sof-plz')?.value.trim() || '';
      const ort = form.querySelector('#sof-ort')?.value.trim() || '';
      const telefon = '';

      const bodyText =
        `━━━ KOSTENLOSE MUSTER-BESTELLUNG ━━━\n\n` +
        `▶ Kunde\n` +
        `Name: ${fullName}\n` +
        `E-Mail: ${emailVal}\n` +
        (telefon ? `Telefon: ${telefon}\n` : '') +
        `\n▶ Versandadresse\n` +
        `${strasse}\n${plz} ${ort}\n\n` +
        `▶ Ausgewählte Muster (${count})\n` +
        titles.map(t => `• ${t}`).join('\n') +
        `\n`;

      if (bodyInput) bodyInput.value = bodyText;

      // Klaviyo: Identify + track (non-blocking, fire-and-forget)
      try {
        const klaviyoProfile = {
          '$email': emailVal,
          '$first_name': vorname,
          '$last_name': nachname,
          '$address1': strasse,
          '$zip': plz,
          '$city': ort,
          '$country': 'DE'
        };
        if (telefon) klaviyoProfile['$phone_number'] = telefon;

        if (typeof window._learnq !== 'undefined') {
          window._learnq.push(['identify', klaviyoProfile]);
          window._learnq.push(['track', 'Requested Free Samples', {
            samples: titles,
            sample_count: count
          }]);
        }
      } catch (_) {}

      // Persist selection for page reload (in case of form errors)
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(selectedSamples.keys())));
      } catch (_) {}

      // Loading state
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      submitBtn.querySelector('.sof-submit__label').textContent = 'Wird gesendet…';

      // Kein Sonderweg mehr: das native Submit des Shopify-Kontaktformulars läuft durch
    });
  }

  // ─── Post-submit state: show success or keep modal open on error ──
  if (config.formSuccess) {
    // Konfigurator-Link aus der gerade bestellten Auswahl bauen, BEVOR der
    // Speicher geleert wird. Der Konfigurator kennt nur ?product=<handle>,
    // vorwählen lässt sich daher genau ein Rahmen – der erste der Bestellung.
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      const handles = stored
        .map(id => (items.find(i => i.dataset.productId === id) || {}).dataset)
        .filter(Boolean)
        .map(d => d.productHandle)
        .filter(Boolean);
      const link = document.querySelector('[data-configurator-return]');
      if (link && handles.length) {
        const base = link.getAttribute('href').split('?')[0];
        link.setAttribute('href', base + '?product=' + encodeURIComponent(handles[0]));
      }
    } catch (_) {}

    // Clear persisted selection
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
    openModal('success');
    // Scroll to top so user sees success message
    window.scrollTo({ top: 0, behavior: 'instant' });
  } else if (config.hasFormErrors) {
    openModal('form');
  }
});
